import { Event, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

/**
 * Filters the `Router`'s events stream to only be `NavigationEnd` events, and casts
 * to get type safety.
 */
export function isNavigationEnd() {
    return (source$: Observable<Event>) =>
        source$.pipe(
            filter((event: Event) => event instanceof NavigationEnd),
            map((event: Event) => event as NavigationEnd)
        );
}
